// extracted by mini-css-extract-plugin
export default {"channel":"Channel_channel__FNCGy","volume":"Channel_volume__YI7ko","buttons":"Channel_buttons__CKrrg","name":"Channel_name__XB5XU","editor":"Channel_editor__N7c8n"};